import { noop } from "lodash";
import React, { FunctionComponent, useCallback } from "react";
import { Checkbox } from "../../components/forms/checkbox";
import { Loader } from "../../components/loader";
import { useAppLoader } from "../../components/loader/app-loader-hook";
import { Widget } from "../../components/widget";
import { AuthService } from "../../store/auth/service";
import { useFetchable } from "../../store/common/fetchable";
import { UsersDTO } from "../../store/users/models/dto";
import { Users } from "../../store/users/reducer";

export const Marketing: React.FunctionComponent<{}> = () => {
  const data = useFetchable(Users.current);
  return <Loader data={[data]}>{([data]) => <InnerPage data={data} />}</Loader>;
};

const InnerPage: FunctionComponent<{
  data: UsersDTO.Responses.GetSingle.T;
}> = ({ data }) => {
  const loader = useAppLoader();
  const toggle = useCallback(() => {
    loader(
      AuthService.updateMarketingSettings({
        receiveMarketingMaterial: !data.receiveMarketingMaterial,
      }).catch(noop)
    );
  }, [data]);

  return (
    <Widget title="Marketing">
      <Checkbox
        label="Receive updates, giveaways and marketing from Sekuritance!"
        onChange={toggle}
        checked={data.receiveMarketingMaterial}
      />
    </Widget>
  );
};
